(function injectPrivacyAgreementStyles() {
  if (document.getElementById('privacy-agreement-styles')) return;
  const style = document.createElement('style');
  style.id = 'privacy-agreement-styles';
  style.textContent = `
    .privacy-agreement-error:not([hidden]) {
      display: block;
      font-size: 12px;
      color: rgb(var(--color-error, 176, 50, 50));
      margin-top: 6px;
    }
    .privacy-checkbox--error {
      outline: 2px solid rgb(var(--color-error, 176, 50, 50));
      outline-offset: 2px;
    }
  `;
  document.head.appendChild(style);
})();

function initPrivacyValidation(form) {
  const checkbox = form.querySelector('[data-privacy-checkbox]');
  if (!checkbox) return;

  const errorEl = document.getElementById(checkbox.getAttribute('aria-describedby'));

  const showError = () => {
    errorEl?.removeAttribute('hidden');
    checkbox.setAttribute('aria-invalid', 'true');
    checkbox.classList.add('privacy-checkbox--error');
    checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    checkbox.focus({ preventScroll: true });
  };

  const clearError = () => {
    errorEl?.setAttribute('hidden', '');
    checkbox.removeAttribute('aria-invalid');
    checkbox.classList.remove('privacy-checkbox--error');
  };

  checkbox.addEventListener('change', clearError);

  // Capture phase fires before any other submit handlers
  form.addEventListener('submit', (e) => {
    if (!checkbox.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
    }
  }, true);
}

window.initPrivacyValidation = initPrivacyValidation;
